module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/college/college-admin.component.css
// module id = ./src/app/admin/college/college-admin.component.css
// module chunks = main